// extracted by mini-css-extract-plugin
export default {"sponsoredLabel":"YarnCard_sponsoredLabel__RALQU","sponsoredLink":"YarnCard_sponsoredLink__uCw0-"};